
import React, { useState } from "react";
import Topratingsfood from "../../Promotionsanddiscounts/Food/Topratingsfood";
import Foodvendorcoupsdetails from "../../Promotionsanddiscounts/Food/Foodvendorcoupsdetails"
import Cancelandrefundpage from "./Cancelandrefundpage";
import Foodsettlementpage from "./Foodsettlementpage";
import CreditsSettlements from "./CreditsSettlements";
import SubscriptionSettlemenst from "./SubscriptionSettlemenst";
const TabsLayout = () => {
  const [activeTab, setActiveTab] = useState("Vendor Settlement");

  const DummySection = ({ title }) => (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );

  const renderComponent = () => {
    switch (activeTab) {
      case "Cancel/Refund":
        return <Cancelandrefundpage />;
      case "Vendor Settlement":
        return <Foodsettlementpage />;
      case "Credits":
        return <CreditsSettlements />;
         case "Subscription":
        return <SubscriptionSettlemenst />;
      // case "Vendor List":
      //   return <Foodvendorcoupsdetails title="Quotation" />;
      // case "Vendor Rating":
      //   return <Topratingsfood title="History" />;

      default:
        return <Cancelandrefundpage />;
    }
  };

  const tabs = [
    // "Cancel/Refund",
    "Vendor Settlement",
    "Credits",
    "Subscription",
    // "Vendor List",
    // "Vendor Rating",

  ];

  return (
    <div className="tabs-wrapper">
      {/* TOP ONE-ROW TABS (ALL SCREENS) */}
      <div className="tabs-row">
        {tabs.map((tab) => (
          <span
            key={tab}
            className={`row-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </span>
        ))}
      </div>

      {/* CONTENT */}
      <div className="tabs-content">
        {renderComponent()}
      </div>
    </div>
  );
};

export default TabsLayout;

